<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :description="$t('analytics.insights.active_vacancies.description').toString()"
            :show-tooltip="true"
            :title="$t('analytics.insights.active_vacancies.title').toString()"
            icon="area-chart"
        >
            <div class="flex items-start justify-center mr-24 mb-32 h-40 leading-none">
                <div class="text-body-sm flex items-center space-x-12">
                    <date-picker
                        v-model="graphFrom"
                        :future-limit="now"
                        :past-limit="pastLimit"
                        disabled
                    />
                    <span class="text-center">{{ $t('analytics.up_until') }}</span>
                    <date-picker
                        v-model="graphTo"
                        :future-limit="now"
                        :past-limit="pastLimit"
                        disabled
                    />
                </div>
            </div>
        </graph-title>
        <div class="w-full">
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"></loading>
            </div>
            <div v-else>
                <div v-if="seriesDataLength > 1" class="h-240">

                    <div class="h-full relative">
                        <apexchart
                            ref="activeVacancies"
                            :options="chartOptions"
                            :series="series"
                            height="100%"
                            type="area"
                            width="100%"
                        ></apexchart>
                    </div>

                </div>
                <div v-else class="flex flex-col px-10">
                    <span class="text-center italic my-16">{{ $t('analytics.empty_series') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as analytics from '../../services/AnalyticsService';
import analyticsMixins from '../../mixins/analyticsMixins';
import GraphTitle from "./GraphTitle";
import VueApexCharts from 'vue-apexcharts';
import chartOptions from '../../config/apex-charts';
import DatePicker from '../forms/DatePicker';
import Loading from '../ui/Loading.vue';
import SvgIcon from '../ui/SvgIcon.vue';
import Moment from 'moment';
import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)

export default {
    components: {
        DatePicker,
        'apexchart': VueApexCharts,
        Loading,
        SvgIcon,
        GraphTitle,
    },
    props: {
        filterFields: {type: Object},
    },
    mixins: [analyticsMixins],
    data: function () {
        return {
            chartOptions: {
                ...chartOptions,
                colors: ["#775DD0"],
                stroke: {
                    show: true,
                },
                xaxis: {
                    ...chartOptions.xaxis,
                    categories: [],
                    labels: {
                        ...chartOptions.xaxis.labels,
                        rotate: 0,
                    },
                    tooltip: {
                        enabled: false,
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    custom: ({series, seriesIndex, dataPointIndex, w}) => {
                        return `
                            <div class="text-body-sm">
                                <div class="pt-12 pl-12 bg-primary-5 border-b border-primary-20">
                                    <div class="mb-12 mr-12 text-center font-semibold">
                                        ${this.formatCategoryFull(w.globals.categoryLabels[dataPointIndex])}
                                    </div>
                                </div>
                                <div class="pt-12 pl-12 bg-white">
                                    <div class="mb-12 mr-12">
                                        <span class="font-semibold">${series[seriesIndex][dataPointIndex]}</span>
                                        <span>${this.$t('analytics.jobs.new')}</span>
                                    </div>
                                </div>
                            </div>
                        `
                    }
                }
            },
            graphFrom: null,
            graphTo: null,
        }
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            return await analytics.activeVacancies(this.filterFields)
                .then(response => {
                    this.graphData = response.data;
                    this.seriesFormat = response.seriesFormat;
                })
                .then(() => this.buildChart())
        },
        buildChart() {
            this.series = JSON.parse(JSON.stringify(this.graphData));
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs.activeVacancies;
                this.setDownloadButtonId(this.graphRef, 'downloadChartActiveVacancies');
            })
        },
    },
}
</script>

<style>
.apexcharts-svg {
    @apply rounded overflow-hidden;
}
</style>
